// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.like-plus-main-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.like-plus-main-banner .main-banner-image .vert-image {
  width: 30rem;
  height: 23rem;
}
@media screen and (max-width: 768px) {
  .like-plus-main-banner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: var(--spacing-regular) var(--spacing-regular) 0 var(--spacing-regular);
  }
  .like-plus-main-banner .main-banner-image {
    margin-top: var(--spacing-regular);
  }
  .like-plus-main-banner .main-banner-image .vert-image {
    width: 22rem;
    height: 17rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/LikePlus/LikePlusMainBannerStyles.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,gBAAA;AADF;AAJA;EASM,YAAA;EACA,aAAA;AAFN;AAQA;EACE;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,8BAAA;IAEA,+EAAA;EAPF;EACA;IASI,kCAAA;EAPJ;EAFA;IAYM,YAAA;IACA,aAAA;EAPN;AACF","sourcesContent":["// DESKTOP\n.like-plus-main-banner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  overflow: hidden;\n\n  .main-banner-image {\n    .vert-image {\n      width: 30rem;\n      height: 23rem;\n    }\n  }\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n  .like-plus-main-banner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n\n    padding: var(--spacing-regular) var(--spacing-regular) 0 var(--spacing-regular);\n\n    .main-banner-image {\n      margin-top: var(--spacing-regular);\n\n      .vert-image {\n        width: 22rem;\n        height: 17rem;\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
